import firebaseApp from '../../utils/firebase'

export default {
  postIntegration({ getters }, { msgKey, type, isNew, i }) {

    const data = {
      org_id: getters.getOrgId,
      sid: getters.bindSID,
      did: msgKey,
      type: type || null,
      ...i || {}
    }

    if (isNew) data.new = isNew

    if (getters.hasIntegrations)
      firebaseApp.Integrations.push(data)

  },
  checkInstallation({ getters }) {

    if (getters.notifyInstall)
      firebaseApp.ref.child('widgets')
        .child(getters.getWidgetId)
        .child('first_install')
        .set(firebaseApp.TIMESTAMP)
        .then(()=>{
          firebaseApp.notifyInstall.push({
            created_at: firebaseApp.TIMESTAMP,
            org_id: getters.getOrgId,
            widget_name: getters.getWidgetName,
            widget_id: getters.getWidgetId,
            url: location.href
          })
        })

  }
}
